<div
  *ngIf="!(connectivity.reachable$ | async)"
  class="connectivity-banner"
  role="alert"
>
  <span class="connectivity-banner__message">{{ connectivity.bannerMessage }}</span>
  <span *ngIf="connectivity.showingCachedData$ | async" class="connectivity-banner__cached">
    Showing previously loaded data.
  </span>
</div>
<router-outlet></router-outlet>
<div [hidden] = "!basicService.showprogress" id="pageloader" class="page-loader flex-column ">
    <span class="spinner-border text-primary" role="status"></span>
    <span class="text-gray-800 fs-6 fw-semibold mt-5">Loading Please Wait...</span>
</div>
  
